import { NavLink } from 'react-router-dom'
import '../styles/header.css'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../features/auth/authSlice'

const Header = () => {
  const { userInfo, isAuthenticated } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

{/* <button className='button' onClick={() => dispatch(logout())}>
          Log Out
          </button> */}
  return (
    <header>
      {/* <div className='header-status text-xl color-green-400'>
         <span>{isAuthenticated ? `Logged in as: ${userInfo.username}` : "You're not logged in"}</span>
        
      </div> */}
      <nav className='container navigation'>
        
        {isAuthenticated ? 
          '' : 
          <>
            {/* <NavLink className='button' to='/'>Home</NavLink> */}
            <NavLink className='button' to='/login'>Login</NavLink>
            <NavLink className='button' to='/register'>Register</NavLink>
            {/* <NavLink className='button' to='/user-profile'>Profile</NavLink> */}
            <NavLink className='button' to='/chat'>Chat</NavLink>
          </>
          }

          {/* <NavLink className='button ' to='/login'>
            Login
          </NavLink>  */}
      </nav>
    </header>
  )
}

export default Header
